var cibPingup = ["32 32", "<path d='M18.224 0h-15.927v32h10.047v-19.041h-3.683c-0.672 0-0.864-0.423-0.427-0.932l5.765-6.724c0.437-0.516 1.156-0.516 1.593 0l5.767 6.724c0.421 0.509 0.239 0.932-0.439 0.932h-3.681v8.901h0.973c8.303 0 11.489-5.745 11.489-11.313 0.016-5.339-3.484-10.547-11.479-10.547z'/>"];

export { cibPingup };
//# sourceMappingURL=cib-pingup.js.map
